import { gql } from "apollo-boost"

export default gql`
  query LoadPrivacyPolicyPage {
    privacyPolicyPage {
      created
      body
    }
  }
`
